import { combineReducers } from "redux";
import auth from "./authReducer";
import services from "./servicesReducer";
import categories from "./categoriesReducer";
import staff from "./staffReducer";
import offers from "./offerReducer";
import packages from "./packagesReducer";
import customers from "./customersReducer";
import serviceProviders from "./serviceProvidersReducer";
import tickets from "./ticketManagementReducer";
import faqs from "./faqsReducer";
import couponCodes from "./couponCodesReducer";
import walletTransactions from "./walletTransactionsReducer";
import walletManagement from "./walletManagementReducer";
import serviceProviderChat from "./serviceProviderChatReducer";
import serviceProviderCustomers from "./serviceProviderCustomersReducer";
import serviceProviderAppointments from "./serviceProviderAppointmentsReducer";
import serviceProviderUserChat from "./serviceProviderUserChatReducer";
import serviceProviderSubscriptions from "./serviceProviderSubscriptionsReducer";
import serviceProviderDashboard from "./serviceProviderDashboardReducer";
import reviews from "./reviewsReducer";
import payment from "./paymentReducer";
import walletInfo from "./walletInfoReducer";
import common from "./commonReducer";
import appointments from "./appointmentsReducer";
import chatAccess from "./chatAccessReducer";
import superAdminDashboard from "./superAdminDashboardReducer";
import superAdminSubscription from "./superAdminSubscriptionReducer";
import subscriptionPlans from "./subscriptionPlanReducer";
import payroll from "./payrollReducer";
import chatConversations from "./chatConversationReducer";
import flashMessages from "./flashMessageReducer";
import addonAndSponsorship from "./addonAndSponsorshipReducer";
import giftCards from "./giftCardReducer";
import organizationSponsorships from "./organizationSponsorshipReducer";
import superAdminServices from "./superAdminServicesReducer";
import pushNotification from "./pushNotificationReducer";

const rootReducer = () =>
  combineReducers({
    auth,
    services,
    staff,
    categories,
    offers,
    packages,
    customers,
    serviceProviders,
    faqs,
    tickets,
    couponCodes,
    walletTransactions,
    walletManagement,
    serviceProviderChat,
    serviceProviderCustomers,
    serviceProviderAppointments,
    serviceProviderUserChat,
    serviceProviderSubscriptions,
    serviceProviderDashboard,
    reviews,
    payment,
    walletInfo,
    common,
    appointments,
    chatAccess,
    superAdminDashboard,
    superAdminSubscription,
    subscriptionPlans,
    payroll,
    chatConversations,
    flashMessages,
    addonAndSponsorship,
    giftCards,
    organizationSponsorships,
    superAdminServices,
    pushNotification
  });

export default rootReducer;
